import { useGetUser } from './use-get-user';
// My defining `options` outside, we have a stable reference to pass to `useUser`,
// avoiding having to `useCallback` the `select`.
const select = (data) => data.hasStaffTimesheets;
export const useHasStaffTimesheets = (options) => useGetUser(undefined, { ...options, select });
//# sourceMappingURL=use-has-staff-timesheets.js.map